import { render, staticRenderFns } from "./DashboardPendingTasksFilter.vue?vue&type=template&id=20b03b40&"
import script from "./DashboardPendingTasksFilter.vue?vue&type=script&lang=ts&"
export * from "./DashboardPendingTasksFilter.vue?vue&type=script&lang=ts&"
import style0 from "./DashboardPendingTasksFilter.vue?vue&type=style&index=0&id=20b03b40&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports